"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConnectivityIcon = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ConnectivityIcon = function ConnectivityIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_core.SvgIcon, _extends({}, props, {
    viewBox: "0 0 24 24"
  }), /*#__PURE__*/_react.default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_5549_299539)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    rx: "12",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    rx: "12",
    fill: "#13131C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.25 17.25C8.25 17.25 7.92605 17.25 7.875 17.25C5.59685 17.25 3.75 15.4032 3.75 13.125C3.75 11.3957 4.81416 9.91489 6.32336 9.30176C7.13223 6.94437 9.36827 5.25 12 5.25C15.1224 5.25 17.6878 7.63513 17.9735 10.6828C19.2982 11.1386 20.25 12.3956 20.25 13.875C20.25 15.6122 18.75 17.25 17.25 17.25H8.25Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.90723 11.7498L12.781 7.8761M12.781 7.8761H10.8441M12.781 7.8761V9.81297M10.8441 13.6867V15.6236M10.8441 15.6236H12.781M10.8441 15.6236L14.7179 11.7498",
    stroke: "#13131C",
    strokeWidth: "1.32862",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_5549_299539"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    rx: "12",
    fill: "white"
  })))));
};
exports.ConnectivityIcon = ConnectivityIcon;